import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import ReactFlagsSelect from "react-flags-select";
import "react-phone-input-2/lib/style.css";
import { FaArrowRight } from "react-icons/fa";
import { addToCart } from "../../../redux/actions/CartActions";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { createCrimRecordRequest } from "../../../redux/actions/FormalityActions";
import Swal from "sweetalert2";
import Loader from "../../../components/loader/Loader";
import FormalityHeader from "../../../components/header/FormalityHeader";
import "../../styles/flow-form.css";

// Validation schema
const validationSchema = Yup.object({
  country: Yup.string().required("Le pays est requis"),
  city: Yup.string().required("La ville est requise"),
});

const countryCityData = {
  CM: [
    { label: "Douala", value: "Douala" },
    // { label: "Yaoundé", value: "Yaoundé" },
  ],
};

function BirthPlace() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.authUser);
  const cart = useSelector((state) => state.cart);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (values) => {
    setSubmitting(true);
    await dispatch(
      addToCart({
        country: values.country,
        city: values.city,
      })
    );

    await dispatch(
      createCrimRecordRequest(
        user.token,
        {
          country: values.country,
          city: values.city,
        },
        handleCallback
      )
    );
  };

  const handleCallback = ({ success, message }) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
    });
    if (success) {
      navigate("/formality-documents");
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
    }
    setSubmitting(false);
  };

  return (
    <div className="legacy-flow">
      <FormalityHeader from={cart.from} />
      <Loader isLoading={submitting} />

      <div className="container mt-3 text-center" style={{ maxWidth: "800px" }}>
        <h4 className="text-center mt-4 mb-4">
          Quel est votre{" "}
          <span style={{ color: "#FF5500" }}>lieu de naissance</span> ?
        </h4>
      </div>

      <div className="container mt-4 d-flex justify-content-center">
        <Formik
          initialValues={{ country: "", city: "" }}
          validationSchema={validationSchema}
          onSubmit={async (values) => {
            handleSubmit(values);
          }}
        >
          {({ setFieldValue, values, errors, touched }) => (
            <Form
              className="w-100"
              style={{ textAlign: "left", maxWidth: "400px" }}
            >
              {/* Country selector */}
              <div className="mb-3">
                <ReactFlagsSelect
                  selected={values.country}
                  countries={["CM"]}
                  onSelect={(code) => {
                    setFieldValue("country", code);
                    setFieldValue("city", null); // Reset city
                  }}
                  placeholder="Pays de naissance"
                  searchable
                  searchPlaceholder="Recherchez le pays"
                  className="w-100"
                />
                {errors.country && touched.country && (
                  <div className="text-danger" style={{ fontSize: "12px" }}>
                    {errors.country}
                  </div>
                )}
              </div>

              {/* City selector */}
              <div className="mb-4">
                <Select
                  options={countryCityData[values.country] || []}
                  value={countryCityData[values.country]?.find(
                    (city) => city.label === values.city
                  )}
                  onChange={(selected) => setFieldValue("city", selected.value)}
                  placeholder="Ville de naissance"
                  isDisabled={!values.country}
                  isSearchable
                />
                {errors.city && touched.city && (
                  <div className="text-danger" style={{ fontSize: "12px" }}>
                    {errors.city}
                  </div>
                )}
              </div>

              {/* Submit button */}
              <div className="d-flex justify-content-center">
                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{
                    backgroundColor: "#051259",
                    borderRadius: "10px",
                    color: "#fff",
                    width: "180px",
                    padding: "10px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  Suivant
                  <FaArrowRight style={{ marginLeft: "8px" }} />
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

export default BirthPlace;
